export const BRAND = {
  name: "Meta Broker Tool",
  shortName: "MBT",
  tagline: "Next-Gen Forex Broker Solutions",
    logo: "/logo.png",
  // For React static assets, use process.env.PUBLIC_URL + '/src/assest/logo.png' in production if needed
  // But best practice: move logo.png to /public and use '/logo.png'
  email: "support@metabrokertools.com",
  email2: "support@metabrokertools.com",
  phone: "+1 (939) 221-0675",
  socials: {
    twitter: "#",
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
};

export const HERO_IMAGES = [
  "https://static.prod-images.emergentagent.com/jobs/d607f970-7256-4c21-bc72-36de5919c454/images/9d6841cd12d516bed346a39d95f119a6b3f7d80d001c679d9fc4e70681428e8b.png",
  "https://images.pexels.com/photos/12955791/pexels-photo-12955791.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
  "https://images.pexels.com/photos/10628030/pexels-photo-10628030.png?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
];

export const CRM_IMAGE = "https://static.prod-images.emergentagent.com/jobs/d607f970-7256-4c21-bc72-36de5919c454/images/831d41111ecf99bfeb836360097dfcb7e3310dad2fa542b6f0247b065fffee76.png";
export const ABOUT_IMAGE = "https://images.pexels.com/photos/10628030/pexels-photo-10628030.png?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
export const KYC_IMAGE = "https://static.prod-images.emergentagent.com/jobs/d607f970-7256-4c21-bc72-36de5919c454/images/932dbb8910d09815763781829a20c239de04047489c87c69ea54a9123623c31d.png";

export const NAV_ITEMS = [
  { label: "Home", href: "/#home", icon: "Home" },
  { label: "About", href: "/#about", icon: "Info" },
  { label: "Fx-Technology", href: "/#fx", icon: "Cpu", hasDropdown: true, dropdownId: "fx" },
  {
    label: "Funded Form",
    href: "/#funded-form",
    icon: "ClipboardList",
    hasDropdown: true,
    dropdownId: "funded",
  },
  { label: "Services", href: "/#services", icon: "Wrench", hasDropdown: true, dropdownId: "services" },
  { label: "Contact", href: "/#contact", icon: "Phone" },
];

export const FX_DROPDOWN = [
  {
    group: "Broker Core",
    items: [
      { title: "Forex CRM", slug: "forex-crm", desc: "Streamlined CRM built for modern brokers.", icon: "Sparkles" },
      { title: "Forex Web Design", slug: "forex-web-design", desc: "High-converting broker websites.", icon: "Layout" },
      { title: "Liquidity Bridge", slug: "liquidity-bridge", desc: "Plug into tier-1 liquidity providers.", icon: "Waves" },
      { title: "Prop Firm CRM", slug: "prop-firm-crm", desc: "Challenge engine for prop shops.", icon: "Lock" },
    ],
  },
  {
    group: "Trading Infra & Tools",
    items: [
      { title: "Forex Copier", slug: "forex-copier", desc: "Instant trade replication across accounts.", icon: "Repeat2" },
      { title: "Dedicated Server", slug: "dedicated-server", desc: "Low-latency MT4 / MT5 hosting.", icon: "Database" },
      { title: "Backend Solutions", slug: "backend-solutions", desc: "Admin, gateways, reporting.", icon: "Globe" },
      { title: "VPS Hosting", slug: "vps-hosting", desc: "Always-on servers for EAs.", icon: "Server" },
      { title: "Custom Tools", slug: "custom-tools", desc: "Tailored utilities for your desk.", icon: "Rocket" },
      {
        title: "Web-Tech",
        href: "/#web-tech",
        desc: "React-first delivery, performance budgets, and engineering standards across builds.",
        icon: "Code2",
      },
    ],
  },
];

/** Mega-menu columns for the Funded Form nav item (`dropdownId: "funded"`). */
export const FUNDED_FORM_DROPDOWN = [
  {
    group: "CRM & Programs",
    items: [
      {
        title: "CRM Marketing Prop Firm",
        slug: "crm-marketing-prop-firm",
        desc: "Positioning, campaigns, and funnel assets tuned for prop-firm and funded-trader programs.",
        icon: "Megaphone",
      },
      {
        title: "CRM Prop Form Tool",
        slug: "crm-prop-form-tool",
        desc: "Configurable forms and workflows for evaluations, payouts, and trader lifecycle events.",
        icon: "FileSpreadsheet",
      },
    ],
  },
  {
    group: "Compliance & Desk Ops",
    items: [
      {
        title: "Regulations",
        slug: "regulations",
        desc: "Compliance-aligned setups and partner checks for funded-program operators.",
        icon: "Landmark",
      },
      {
        title: "Consulting",
        slug: "consulting",
        desc: "Launch planning, vendor choices, and operating-model advisory for funded desks.",
        icon: "UserStar",
      },
      {
        title: "Risk Management",
        slug: "risk-management",
        desc: "Exposure, concentration, and policy-backed limits across funded accounts.",
        icon: "ShieldAlert",
      },
      {
        title: "Manpower",
        slug: "manpower",
        desc: "Staffing and team augmentation so your funded desk can scale operations cleanly.",
        icon: "Users",
      },
    ],
  },
];

/** Long-form copy for `/solutions/:slug` pages (aligned with About, Services, Web-Tech, Contact). */
export const FX_SOLUTION_DETAIL = {
  "forex-crm": {
    intro: "Unify onboarding, wallets, IB trees, and support in one operator-grade CRM.",
    paragraphs: [
      "Forex CRM is the control room for your desk: KYC states, deposit rails, ticket queues, and IB payouts all need to stay in sync when markets move fast. We build workflows that match how retail and hybrid brokers actually run day-to-day operations.",
      "Every screen is tuned for compliance-friendly audit trails and role-based access, so sales, risk, and support can collaborate without stepping on each other's permissions.",
    ],
    highlights: [
      "Trader's room flows for KYC, funding, and withdrawals",
      "IB hierarchy with transparent accruals and statements",
      "Risk snapshots surfaced next to client profiles",
      "Integrations with bridges, PSPs, and ticketing tools",
    ],
  },
  "forex-web-design": {
    intro: "Launch broker sites that load fast, rank well, and convert demos into funded accounts.",
    paragraphs: [
      "Your website is still the first compliance touchpoint many traders see. We pair sharp visual direction with disciplined information architecture — clear product tiers, jurisdiction notes, and frictionless demo CTAs.",
      "Design systems stay consistent from marketing pages into authenticated trader areas, so the brand handoff feels intentional rather than bolted on.",
    ],
    highlights: [
      "Performance-first React builds with SEO fundamentals",
      "Localized layouts for multi-region campaigns",
      "Component libraries shared with trader portals",
      "Accessibility and readability baked into typography",
    ],
  },
  "liquidity-bridge": {
    intro: "Connect platforms to aggregated liquidity with predictable latency and failover paths.",
    paragraphs: [
      "A bridge is only as good as its failure modes. We engineer routing rules, margin checks, and session recovery so spikes in volatility do not translate into mystery rejects for your traders.",
      "Whether you are aggregating multiple LPs or staging a migration, we document every hop and give your ops team the telemetry they need.",
    ],
    highlights: [
      "Symbol mapping and session management across venues",
      "Health dashboards for feeds and execution quality",
      "Staged rollouts for LP onboarding",
      "Runbooks aligned with your risk policy",
    ],
  },
  "prop-firm-crm": {
    intro: "Run challenges, evaluations, and payouts with CRM logic built for prop workflows.",
    paragraphs: [
      "Prop desks break when challenge rules live in spreadsheets. We codify drawdowns, consistency rules, and payout ladders directly into the CRM so support always sees the same truth as risk.",
      "Trader journeys stay transparent — fewer disputes, faster resolutions, and cleaner month-end reporting.",
    ],
    highlights: [
      "Challenge state machines with auditable transitions",
      "Payout queues with approval roles",
      "Leaderboards and progress surfaces for traders",
      "Hooks for payment providers and KYC vendors",
    ],
  },
  "forex-copier": {
    intro: "Copy trades across master and follower accounts with guardrails your risk team can trust.",
    paragraphs: [
      "Copy trading is a product surface and a risk surface. We implement lot scaling, symbol filters, and exposure caps so popular masters do not silently stack correlated positions across thousands of followers.",
      "Latency-sensitive paths are profiled early — replication is only valuable if it arrives consistently during fast markets.",
    ],
    highlights: [
      "Flexible allocation models (fixed, proportional, equity-based)",
      "Circuit breakers for drift and disconnects",
      "Master/follower analytics for compliance review",
      "APIs for white-label partner integrations",
    ],
  },
  "dedicated-server": {
    intro: "Host MT4 / MT5 and supporting services on infrastructure sized for your peak sessions.",
    paragraphs: [
      "Dedicated metal still matters for certain matching and bridge workloads. We size CPU, disk IO, and network paths against your symbol mix instead of generic templates.",
      "Patch windows, backups, and monitoring are treated as part of the product — not hidden ops to chase later.",
    ],
    highlights: [
      "Baseline benchmarking before go-live",
      "Monitoring with actionable alerts",
      "Regional placement options",
      "Handover documentation your internal IT can own",
    ],
  },
  "backend-solutions": {
    intro: "Admin consoles, gateways, and reporting pipelines that keep broker operations coherent.",
    paragraphs: [
      "Backend work is where desks differentiate pricing, credit, and workflow. We ship admin tools that mirror your policy documents — not generic CRUD screens that fight your processes.",
      "Reporting layers connect trading, CRM, and finance so month-end is reconciliation, not archaeology.",
    ],
    highlights: [
      "Role-based admin with fine-grained permissions",
      "Gateway patterns for payments and liquidity",
      "Scheduled reports and export pipelines",
      "Service boundaries that scale with headcount",
    ],
  },
  "vps-hosting": {
    intro: "Keep EAs and lightweight services running on resilient VPS tiers with clear SLAs.",
    paragraphs: [
      "Retail traders expect their EAs to survive reboots and provider hiccups. We automate snapshots, patch cycles, and proactive notices so support tickets do not spike after every maintenance window.",
      "Sizing guidance ties instance types to realistic concurrent workloads.",
    ],
    highlights: [
      "Image templates tuned for trading stacks",
      "Bandwidth and latency monitoring",
      "Optional managed backups",
      "Upgrade paths when desks outgrow starter tiers",
    ],
  },
  "risk-management": {
    intro: "Monitor exposure, concentration, and stress scenarios before they become desk-wide incidents.",
    paragraphs: [
      "Risk tooling should meet traders and operators where they work — dashboards, alerts, and drill-downs that answer 'who is long what, across which books?' in seconds.",
      "We align metrics with your policy language so audits and internal reviews map cleanly to the screens your team already trusts.",
    ],
    highlights: [
      "Real-time exposure by symbol, book, and region",
      "Scenario templates for shocks and gaps",
      "Alert routing to Slack, email, or ticketing",
      "Historical replay for post-mortems",
    ],
  },
  "custom-tools": {
    intro: "Ship desk-specific utilities — from internal consoles to trader-facing calculators.",
    paragraphs: [
      "Not every edge case belongs in an off-the-shelf product. We prototype quickly, harden against production traffic, and document handover so your engineers can extend the tool later.",
      "Stacks match the rest of our delivery: typed APIs, observable jobs, and UI systems consistent with your public surfaces.",
    ],
    highlights: [
      "Rapid discovery workshops with desk stakeholders",
      "Security reviews for sensitive data paths",
      "Automated tests around business-critical rules",
      "Deployment into your preferred environment",
    ],
  },
  consulting: {
    intro: "Pressure-test roadmaps, vendor choices, and launch plans with engineers who have shipped dozens of desks.",
    paragraphs: [
      "Consulting engagements stay pragmatic: architecture reviews, cutover plans, and honest tradeoffs between build, buy, and integrate.",
      "We translate regulatory and commercial constraints into engineering milestones your leadership can track.",
    ],
    highlights: [
      "Architecture and integration reviews",
      "Vendor RFP support with scoring rubrics",
      "Launch readiness checklists",
      "Post-launch tuning sprints",
    ],
  },
  "crm-marketing-prop-firm": {
    intro: "Grow funded and prop programs with CRM-connected marketing that respects compliance boundaries.",
    paragraphs: [
      "Funded-form businesses live or die on trust and clarity. We wire landing pages, email journeys, and trader-facing messaging into your CRM so every touchpoint reflects the same rules, disclosures, and funnel logic.",
      "Campaign structures are built for prop-style journeys — evaluations, resets, and payouts — without fragmenting attribution or support handoffs.",
    ],
    highlights: [
      "CRM-aligned landing and nurture flows",
      "Consistent disclosures across regions and partner programs",
      "Attribution that maps to desk and IB reporting",
      "Playbooks for launches, promos, and seasonal pushes",
    ],
  },
  "crm-prop-form-tool": {
    intro: "Digitize evaluations, agreements, and payouts with forms that plug straight into your CRM.",
    paragraphs: [
      "Paper PDFs and one-off Google Forms create disputes. We ship validated forms, routing, and approvals so risk and support always see the same submission history.",
      "Rules engines encode drawdowns, consistency checks, and payout eligibility — fewer manual overrides, cleaner audits.",
    ],
    highlights: [
      "Multi-step forms with role-based approvals",
      "Versioned terms and consent trails",
      "Webhooks into payouts, ticketing, and risk tools",
      "Templates for resets, upgrades, and appeals",
    ],
  },
  manpower: {
    intro: "Augment your funded desk with engineers, analysts, and operators who already speak broker workflows.",
    paragraphs: [
      "Scaling headcount is painful when every hire needs six months of domain ramp-up. We place embeddable talent — from CRM admins to risk analysts — using your stack and your runbooks.",
      "Engagements stay flexible: surge coverage for launches, ongoing fractional roles, or hybrid pods tied to milestones.",
    ],
    highlights: [
      "Pre-vetted profiles across tech, ops, and risk",
      "Overlap plans so knowledge does not walk out the door",
      "Security and access patterns aligned to your policy",
      "Clear handover when you bring roles in-house",
    ],
  },
  regulations: {
    intro: "Navigate compliance expectations with integration patterns that respect jurisdictional nuance.",
    paragraphs: [
      "We do not provide legal advice — we build software that makes it easier for your counsel's requirements to show up in product behavior: data residency hooks, consent trails, and partner due diligence artifacts.",
      "Partner networks are documented so your compliance team knows which integrations carry which attestations.",
    ],
    highlights: [
      "KYC/AML workflow hooks with auditable states",
      "Data minimization patterns in forms and APIs",
      "Checklists for partner onboarding reviews",
      "Documentation packs for regulatory exams",
    ],
  },
};

export const FX_SOLUTION_CROSS_LINKS = [
  { label: "About", href: "/#about", blurb: "How we think about the full broker stack." },
  { label: "Services", href: "/#services", blurb: "Web, mobile, and CRM delivery lanes." },
  { label: "Web-Tech", href: "/#web-tech", blurb: "Engineering standards across builds." },
  { label: "Contact", href: "/#contact", blurb: "Book a discovery call with our team." },
];

function pickDropdownForSlug(slug) {
  for (const col of FX_DROPDOWN) {
    const item = col.items.find((i) => i.slug === slug);
    if (item) return { col, item, parentSection: "Fx-Technology", parentSectionHref: "/#fx" };
  }
  for (const col of FUNDED_FORM_DROPDOWN) {
    const item = col.items.find((i) => i.slug === slug);
    if (item) return { col, item, parentSection: "Funded Form", parentSectionHref: "/#funded-form" };
  }
  return null;
}

export function getFxSolutionBySlug(slug) {
  const detail = FX_SOLUTION_DETAIL[slug];
  if (!detail) return null;
  const picked = pickDropdownForSlug(slug);
  if (!picked) return null;
  const { col, item, parentSection, parentSectionHref } = picked;
  return {
    ...item,
    group: col.group,
    intro: detail.intro,
    paragraphs: detail.paragraphs,
    highlights: detail.highlights,
    parentSection,
    parentSectionHref,
  };
}

export const HERO_FEATURES = [
  { title: "Bank-Grade Security", icon: "ShieldCheck", accent: "blue" },
  { title: "Sub-Millisecond Execution", icon: "Zap", accent: "orange" },
  { title: "Dedicated Onboarding", icon: "Users", accent: "blue" },
  { title: "24 / 7 Support Desk", icon: "Headphones", accent: "orange" },
];

export const HERO_STATS = [
  { value: "500+", label: "Broker Deployments" },
  { value: "98%", label: "Uptime SLA" },
  { value: "24/7", label: "Trading Support" },
];

export const ABOUT_FEATURES = [
  { icon: "Zap", text: "Ultra-modern trader interface — crisp, responsive, lightning fast" },
  { icon: "Repeat", text: "Frictionless onboarding with real-time KYC controls" },
  { icon: "Users", text: "PAMM & MAM with investor support built in" },
  { icon: "LayoutDashboard", text: "Unified Trader's Room with advanced analytics" },
  { icon: "Network", text: "Smart IB structure — layered and infinitely scalable" },
  { icon: "GitFork", text: "Powerful Copier System — simple but industrial-grade" },
];

/** DOM id / URL hash for each homepage service row — keep in sync with `Services.jsx`. */
export function serviceSectionHashId(title) {
  const slug = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `service-${slug}`;
}

/** URL slug for each service page under `/services/:slug`. */
export function serviceSlug(title) {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export const SERVICES = [
  { title: "Static Website Development", desc: "Fast, SEO-friendly static sites with clean, modern design.", icon: "FileText" },
  { title: "Dynamic Web Platforms", desc: "Interactive applications built to convert and retain users.", icon: "RefreshCw" },
  { title: "E-commerce Builds", desc: "Scalable, secure storefronts engineered for revenue.", icon: "ShoppingCart" },
  { title: "Android App Development", desc: "Robust Android apps with native-grade performance.", icon: "Smartphone" },
  { title: "iOS App Development", desc: "Elegant, efficient iOS apps for iPhone & iPad.", icon: "Apple" },
  { title: "CRM Consulting", desc: "Pick and optimize the CRM stack that fits your desk.", icon: "Headphones" },
  { title: "CRM Implementation", desc: "Seamless rollout matched to your exact workflow.", icon: "Settings" },
  { title: "CRM Integration", desc: "Wire your CRM into trading, payments, and data tools.", icon: "Link" },
];

function serviceToMegaMenuItem(s) {
  return {
    title: s.title,
    desc: s.desc,
    icon: s.icon,
    slug: serviceSlug(s.title),
  };
}

/** Mega-menu columns for the Services nav item (`dropdownId: "services"`). */
export const SERVICES_DROPDOWN = [
  {
    group: "Web & storefronts",
    items: [SERVICES[0], SERVICES[1], SERVICES[2]].map(serviceToMegaMenuItem),
  },
  {
    group: "Mobile apps",
    items: [SERVICES[3], SERVICES[4]].map(serviceToMegaMenuItem),
  },
  {
    group: "CRM",
    items: [SERVICES[5], SERVICES[6], SERVICES[7]].map(serviceToMegaMenuItem),
  },
];

export const SERVICES_DETAIL = {
  "static-website-development": {
    intro: "Fast, SEO-ready marketing sites with a modern design system and clean content structure.",
    paragraphs: [
      "Static builds are ideal for broker and funded-brand marketing when you want reliability, speed, and predictable hosting. We ship crisp layouts, strong information architecture, and conversion-ready CTAs.",
      "Performance budgets, accessibility, and analytics hooks are treated as first-class requirements — not afterthoughts.",
    ],
    highlights: [
      "Lightning-fast pages with SEO fundamentals",
      "Reusable design system + component library",
      "Analytics + tracking plan aligned to funnels",
      "Deployment-ready builds (Netlify, Vercel, S3, etc.)",
    ],
  },
  "dynamic-web-platforms": {
    intro: "Interactive web applications built to convert, onboard, and retain users at scale.",
    paragraphs: [
      "When your product needs dashboards, forms, and authenticated experiences, we build dynamic platforms with a clean UI system and typed integrations.",
      "We prioritize stable UX, predictable state management, and observability so your team can iterate safely after launch.",
    ],
    highlights: [
      "Authenticated portals and admin surfaces",
      "Form workflows with validation + audit trails",
      "API integration patterns and error handling",
      "Performance profiling and monitoring-ready setup",
    ],
  },
  "e-commerce-builds": {
    intro: "Secure storefronts engineered for revenue — with UX that keeps checkout friction low.",
    paragraphs: [
      "E-commerce is a funnel: listings, pricing, cart logic, and checkout need to be consistent and measurable. We build storefronts with clean catalog structure and conversion-focused layouts.",
      "Integrations are designed for reliable operations — refunds, reporting, and inventory or SKU logic where relevant.",
    ],
    highlights: [
      "Conversion-first storefront UX and IA",
      "Payments + tax/shipping integrations (as needed)",
      "Order status + email flows",
      "Reporting-friendly data capture",
    ],
  },
  "android-app-development": {
    intro: "Robust Android apps with native-grade performance and reliable release pipelines.",
    paragraphs: [
      "We build Android apps that feel fast, stable, and consistent with your brand system — from onboarding to notifications and account flows.",
      "Security, offline behavior, and crash monitoring are handled early so production usage is predictable.",
    ],
    highlights: [
      "Onboarding + auth flows with secure storage",
      "API integration and offline-friendly patterns",
      "Crash/analytics instrumentation",
      "Release process and store readiness support",
    ],
  },
  "ios-app-development": {
    intro: "Elegant iOS apps engineered for smooth UX, strong security posture, and maintainable code.",
    paragraphs: [
      "iOS users expect polish: animations, navigation, and responsiveness need to be consistent. We ship iOS apps that match those expectations without sacrificing reliability.",
      "We also help with store compliance, signing, and release workflows so updates remain routine rather than stressful.",
    ],
    highlights: [
      "Polished UI with consistent navigation",
      "Secure auth + data handling",
      "Analytics + event tracking for funnels",
      "App Store submission and release workflows",
    ],
  },
  "crm-consulting": {
    intro: "Choose and optimize the CRM stack that fits your desk, workflows, and compliance needs.",
    paragraphs: [
      "CRMs fail when the process is unclear. We map your onboarding, funding, support, and IB flows, then recommend a stack that matches your operating model — not generic vendor checklists.",
      "You get pragmatic deliverables: workflow maps, integration diagrams, and an implementation plan your team can execute.",
    ],
    highlights: [
      "Workflow mapping + gap analysis",
      "Vendor evaluation and scoring rubrics",
      "Integration and data model review",
      "Launch readiness checklists",
    ],
  },
  "crm-implementation": {
    intro: "A clean CRM rollout matched to your exact workflow — with roles, audit trails, and integrations.",
    paragraphs: [
      "Implementation is where policy becomes product. We configure roles, permission boundaries, and auditable states so ops, sales, and compliance can collaborate safely.",
      "We stage launches to reduce operational risk and keep your team in control during cutovers.",
    ],
    highlights: [
      "Role-based setup and audit-friendly workflows",
      "KYC/PSP/bridge integrations where needed",
      "Staged rollout plan with runbooks",
      "Training + handover for internal ownership",
    ],
  },
  "crm-integration": {
    intro: "Wire your CRM into trading, payments, and data tools with resilient, observable integrations.",
    paragraphs: [
      "Integrations must survive edge cases: retries, idempotency, partial failures, and reconciliation. We build integration layers that keep data consistent across systems.",
      "Monitoring and logs are included so your team can diagnose issues quickly without guesswork.",
    ],
    highlights: [
      "Webhook + queue patterns for reliability",
      "Reconciliation and replay strategies",
      "Monitoring and alerting hooks",
      "Documentation for long-term maintainability",
    ],
  },
};

export function getServiceBySlug(slug) {
  const base = SERVICES.find((s) => serviceSlug(s.title) === slug);
  if (!base) return null;
  const detail = SERVICES_DETAIL[slug];
  if (!detail) return null;
  return {
    ...base,
    slug,
    intro: detail.intro,
    paragraphs: detail.paragraphs,
    highlights: detail.highlights,
  };
}

export const WHY_CHOOSE_FAQ = [
  { q: "Ongoing support and maintenance that keeps you live 24/7", a: "Our dedicated success team monitors your platform around the clock, ships security patches, and continuously optimizes performance so your desk never sleeps." },
  { q: "Expert team with deep forex + software engineering experience", a: "We blend capital markets veterans with senior full-stack engineers — you get people who understand both the trade and the stack behind it." },
  { q: "Customized solutions tailored to your unique business model", a: "Whether you run a retail broker, a prop firm, or a hybrid model, every deliverable is tuned to your rulebook, risk policy, and brand." },
  { q: "Cutting-edge technology and innovation baked in", a: "From low-latency matching to AI-assisted risk scoring, we pull from the same toolbelt powering tier-1 institutional desks." },
  { q: "Fast delivery with transparent, competitive pricing", a: "Clear milestones, fixed scopes where possible, and a no-surprise billing model. You always know what you're paying for." },
];

export const COMPLIANCE_POINTS = [
  { title: "Regulated Partners Only", desc: "We integrate exclusively with verified, licensed broker partners." },
  { title: "No Trading or Advisory", desc: "We're a technology vendor — we never offer financial advice or execution." },
  { title: "Compliance-First Integrations", desc: "Every workflow ships aligned with KYC/AML and partner legal frameworks." },
];

export const CTA_POINTS = [
  { icon: "Lightbulb", text: "Innovative Solutions Tailored to Your Desk" },
  { icon: "Users", text: "Senior Team Supporting Every Launch" },
  { icon: "Timer", text: "Fast Turnaround & Reliable Delivery" },
  { icon: "ShieldCheck", text: "Secure & Scalable Technology Stack" },
];

export const MARQUEE_ITEMS = [
  { icon: "Users", text: "Senior Engineering Team" },
  { icon: "Award", text: "ISO-Aligned Delivery" },
  { icon: "Zap", text: "Sub-Millisecond Execution" },
  { icon: "Phone", text: "24/7 Dedicated Support" },
  { icon: "Globe", text: "Global Multi-Region Hosting" },
  { icon: "ShieldCheck", text: "Bank-Grade Security" },
];
